import { Link } from 'react-router-dom'
import { useState } from 'react'
import { useAuth } from '../context/AuthContext'
import globalStyles from '../styles/global.module.css'
import styles from './Header.module.css'
import pctLogo from '../images/pctLogo.svg'

const Header = () => {
  const { user, logout } = useAuth()
  const [menuOpen, setMenuOpen] = useState(false)

  const handleLogout = async () => {
    await logout()
    setMenuOpen(false)
  }

  const toggleMenu = () => {
    setMenuOpen(!menuOpen)
  }

  return (
    <header className={globalStyles.header}>
      <div className={globalStyles.headerContent}>
        <div className={styles.titleContainer}>
          <img src={pctLogo} alt="PCT Logo" className={styles.logo} />
          <h1 className={globalStyles.title}>
            <Link to="/" className={styles.titleLink}>Max's Pacific Crest Trail Blog</Link>
          </h1>
        </div>
        
        <div className={styles.hamburger} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        
        <nav className={`${styles.nav} ${menuOpen ? styles.navOpen : ''}`}>
          <Link to="/gear" className={globalStyles.navLink} onClick={() => setMenuOpen(false)}>Gear</Link>
          <Link to="/gps" className={globalStyles.navLink} onClick={() => setMenuOpen(false)}>Satellite Tracker</Link>
          <Link to="/faqs" className={globalStyles.navLink} onClick={() => setMenuOpen(false)}>FAQs</Link>

          <Link to="/posts" className={globalStyles.navLink} onClick={() => setMenuOpen(false)}>Posts</Link>

          {user && (
            <>
              <Link to="/admin" className={globalStyles.navLink} onClick={() => setMenuOpen(false)}>Admin</Link>
              <button 
                onClick={handleLogout} 
                className={styles.logoutButton}
              >
                Logout
              </button>
            </>
          )}
        </nav>
      </div>
    </header>
  )
}

export default Header 